import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import moment from 'moment'
import Print from 'vue-print-nb'
import { hiPrintPlugin } from 'vue-plugin-hiprint'
import { setupPermissionDirective } from './directives/permission'
import { setRole } from './utils/permission'

Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(Print)
Vue.use(hiPrintPlugin, '$hiprint', false)

Vue.prototype.$moment = moment

setupPermissionDirective(Vue)

setRole('admin')

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
